import { useState } from "react";
import { motion } from "framer-motion";

import { revealContainer, fadeUp } from "../lib/motionVariants";

/** RST Reactor exposes a wdth axis over 1–9; the tester reads like the one shipped on family pages. */
export default function AxisTester() {
  const [wdth, setWdth] = useState(6.2);

  return (
    <motion.section
      variants={revealContainer}
      initial="hidden"
      whileInView="show"
      viewport={{ once: true, amount: 0.3 }}
      className="border-b border-ink-200 py-7 md:py-12"
    >
      <motion.div variants={fadeUp} className="flex flex-wrap items-baseline justify-between gap-5">
        <p className="font-mono text-[11px] uppercase tracking-[0.2em] text-muted">Variable axes, handled natively</p>
        <p className="font-mono text-[11px] tracking-[0.14em] text-primary">wdth {wdth.toFixed(1)} / 9.0</p>
      </motion.div>

      <motion.div variants={fadeUp} className="overflow-hidden py-2 md:py-4">
        <div
          className="unselectable whitespace-nowrap font-reactor text-[clamp(40px,11vw,150px)] font-bold leading-[0.9]"
          style={{ fontVariationSettings: `'wdth' ${wdth}` }}
        >
          TYPE SPECIMEN
        </div>
      </motion.div>

      <motion.div variants={fadeUp}>
        <input
          type="range"
          min="1"
          max="9"
          step="0.05"
          value={wdth}
          aria-label="Width axis"
          className="axis-range"
          onChange={(e) => setWdth(parseFloat(e.target.value))}
        />

        <p className="mt-3.5 font-mono text-[10.5px] uppercase tracking-[0.14em] text-muted">
          Your customers get this tester on every family page — axes, instances and glyph tables read
          straight from the font you upload.
        </p>
      </motion.div>
    </motion.section>
  );
}
